import React, { useState } from 'react';
import './miniSubscribeBtn.scss';
import { subscribeEamil } from '../../../../lib/subscribe';

const MiniSubscribeBtn = () => {
  const [email, setEmail] = useState<string>('');

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await subscribeEamil(email!);
    setEmail('');
  };
  return (
    <div className="mini-subscribeBtn-layout">
      <form onSubmit={onSubmit}>
        <label htmlFor="subscribe">
          <div className="sub-box">
            <img src="/seamansclub-news/assets/svg/arrow-down.svg" alt="" className="down-icon" />
            <div>
              <div className="title">SubScribe Today!</div>
              <div className="message">
                <p className="sub-meg">We are preparing a news letter service.</p>
                <p className="sub-meg">If you enter your email address,</p>
                <p className="sub-meg">we will send you an email after the service opens.</p>
              </div>
            </div>
            <img src="/seamansclub-news/assets/svg/arrow-down.svg" alt="" className="down-icon" />
          </div>
        </label>
        <div className="subscribe-btn-box ">
          <input
            value={email}
            type="email"
            id="subscribe"
            placeholder="Enter Your Email Address:D"
            className="email-input"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
          />
          <div className="subscribe-divide"></div>
          {/* TODO : api 적용시 SUBSCRIBE! 로 변경 */}
          <button type="submit" className="subscribe-btn">
            SUBSCRIBE!
          </button>
        </div>
      </form>
    </div>
  );
};

export default MiniSubscribeBtn;
